import { GaTrackingEventName, GATrackingEventType } from '../../constants';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEvent } from '../ga-tracking-event.model';

export class GaTrackingChangeDeliveryAddressEvent implements GATrackingEvent {
  constructor(private payload: any) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.ChangeDeliveryAddress;
  }

  getPayload(): GATrackingEventPayload {
    return {
      ...this.payload,
      event: GaTrackingEventName.Notifications,
      gtmCustom: {
        ...this.payload?.gtmCustom,
        action: 'Popup on checkout with invalid region offer'
      }
    };
  }
}
